import React from 'react';
import { motion } from 'framer-motion';

const SolutionStrategies = () => {
	return (
	    <>
	    {/* New Section with Green Gradient Background */}
    <section className="relative min-h-screen sm:h-[100vh] lg:h-[80vh] xl:h-[70vh] 2xl:h-[90vh] flex items-center overflow-hidden py-12 sm:py-16 md:py-20" style={{ background: 'linear-gradient(180deg, #FFFFFF 23.08%, #42FF00 100%)' }}>
        
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-12 sm:py-16 md:py-20 w-full relative z-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 md:gap-12 items-center">
                {/* Left Side - Title */}
                <motion.div 
                    className="relative z-10 text-center lg:text-left order-1"
                    initial={{ x: -50, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-source font-semibold text-[#113861] mb-3 sm:mb-4 leading-tight">
                        Strategies
                    </h2>
                    <h3 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-source italic font-regular text-[#113861] leading-tight">
                        that Empower
                    </h3>
                </motion.div>

                {/* Right Side - Paragraph */}
                <motion.div 
                    className="relative z-10 text-center lg:text-left order-2"
                    initial={{ x: 50, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                >
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl font-sans font-regular text-[#2b2b2b] leading-relaxed max-w-lg sm:max-w-xl md:max-w-2xl lg:max-w-none mx-auto lg:mx-0">
                        Clarity isn't just a destination, it's where it all begins. Our science backed assessments and research-based tools empower individuals and institutions to make clear decisions, gain self-awareness, and take confident steps toward personal and professional growth. Whether it's helping students identify their academic and career pathways or supporting educational institutions with evidence-based strategies, we exist to deliver transformative outcomes rooted in scientific integrity and cultural intelligence.
                    </p>
                </motion.div>
            </div>

            {/* Image Section - Positioned below content on smaller screens */}
            <motion.div 
                className="relative z-10 mt-12 sm:mt-16 md:mt-20 lg:hidden flex justify-center"
                initial={{ scale: 0.8, opacity: 0 }}
                whileInView={{ scale: 1, opacity: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 1, ease: "easeOut" }}
            >
                <img
                    src="/images/sol-image.png"
                    alt="Translucent gear graphic"
                    className="w-64 h-64 sm:w-80 sm:h-80 md:w-96 md:h-96 object-contain opacity-60"
                    style={{ filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))' }}
                />
            </motion.div>
        </div>

        {/* Desktop Image - Positioned absolutely for larger screens */}
        <motion.div 
            className="hidden lg:block absolute top-0 left-0 z-0 w-full h-full flex items-start justify-start lg:left-10 lg:top-10 xl:left-0 xl:top-60 2xl:left-30 2xl:top-30"
            initial={{ scale: 0.8, opacity: 0 }}
            whileInView={{ scale: 1, opacity: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: "easeOut" }}
        >
            <img
                src="/images/sol-image.png"
                alt="Translucent gear graphic"
                className="w-[600px] h-[600px] xl:w-[1000px] xl:h-[1000px] object-contain opacity-100"
                style={{ filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))' }}
            />
        </motion.div>
    </section>
</>
	);
};

export default SolutionStrategies;